import { render } from "./SearchTelasPage.vue?vue&type=template&id=1cf5cbcb&lang=pug"
import script from "./SearchTelasPage.vue?vue&type=script&lang=js"
export * from "./SearchTelasPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__